import ForumAPIRequest from "messaging/entities/forum/api/request-contracts/forum-api-request";
import Message from "messaging/entities/message/message";

type BulkMessageRequest = {
  id?: string;  forum?: ForumAPIRequest;
  subject: string;
  contentPlainText: string;
  markCreated: boolean;
  markDeleted: boolean;
  markRead: boolean;
  markUnread: boolean;
  isAutoGenerated: boolean;
  publish?: boolean;
}

export default class BulkMessageAPIRequest {
  public payload: Array<BulkMessageRequest>;

  constructor(messages: Message[]) {
    this.payload = [];
    messages.forEach((message) => {
      this.payload.push({
        id: message.id?.value,
        forum: new ForumAPIRequest(message.forum),
        subject: message.subject ?? "",
        contentPlainText: message.content,
        markCreated: message.markedForCreation ?? false,
        markDeleted: message.markedForDeletion ?? false,
        markRead: message.markedRead ?? false,
        markUnread: message.markedUnread ?? false,
        isAutoGenerated: message.isAutoGenerated ?? false,
        publish: message.markedForPublish ?? false
      });
    });
  }
}
